import _ from '../../common/utility';

function facultyBioVideo() {

    //Bio Video open modal
    $(".hp_faculty .faculty_list .faculty").each(function () {
        if ($(this).find('.faculty_details a').length === 1) {
            let bioLink = $(this).find('.faculty_details a');
            bioLink.on('click', function (e) {
                e.preventDefault();
                let videoSrc = bioLink.attr("href")
                facultyBioVideoPopUp(videoSrc);
            });
        }
    });

    const facultySection = document.querySelector('section.hp_faculty');
	if (facultySection) {
        const contributors = facultySection.querySelectorAll('.modal-content .disclosures-person .disclosures-person-name');

        // don't rpoceed if there are no contributors
        if(contributors.length === 0) return;

        const titli = facultySection.querySelector('.section_title');
		const h3 = document.createElement('h3');
		h3.innerText = 'Disclosures';
		// @ts-ignore //src: https://stackoverflow.com/a/32135318
		titli.parentNode.insertBefore(h3, titli.nextSibling);
		h3.addEventListener('click', () => {
			// @ts-ignore
			createModal(facultySection).then((modalEl) => {
				modalEl.classList.add('is-open');
				const body = document.getElementsByTagName('body')[0];
                body.insertBefore(modalEl, body.firstChild);
				body.classList.add('scroll-locked-background');
				const closeModalBTN = modalEl.querySelector('.close-modal.js-close-modal');
				closeModalBTN.addEventListener('click', () => {
					modalEl.classList.remove('is-open');
					body.classList.remove('scroll-locked-background');
				});
			});
		});
        // h3.click();
	}
}


function facultyBioVideoPopUp(src) {

    //Create Video Modal
    let bioVideoDiv = document.createElement("div");
    bioVideoDiv.id = "faculty-biovideo-container"


    let layerBg = document.createElement("div");
    layerBg.className = "faculty-biovideo-layer-background";

    bioVideoDiv.appendChild(layerBg);

    let videoArea = document.createElement("div");
    videoArea.className = "faculty-biovideo-layer-videoArea";

    let closeDivArea = document.createElement("div")
    closeDivArea.className = "faculty-biovideo-video";

    let spanCloseButton = document.createElement("span");
    spanCloseButton.id = "faculty-biovideo-container--close"

    let closeX = document.createTextNode("X");

    spanCloseButton.appendChild(closeX);
    closeDivArea.appendChild(spanCloseButton);

    let videoDiv = document.createElement("video");
    videoDiv.setAttribute("class", "faculty-bio-video--video");
    videoDiv.setAttribute("controls", "");
    videoDiv.setAttribute("preload", "metadata");
    videoDiv.setAttribute("controlslist", "nodownload");
    videoDiv.setAttribute("src", src);
    videoDiv.setAttribute("autoplay", "autoplay");

    bioVideoDiv.appendChild(videoArea).appendChild(closeDivArea).appendChild(videoDiv);

    //Append Video modal adjacent to body tag
    window.document.body.insertBefore(bioVideoDiv, window.document.body.firstChild);


    //Modal pop-up Close Functionality
    spanCloseButton.onclick = function(){
        bioVideoDiv.remove();
    };

}

function createModal(facultySection) {
	return new Promise((resolve) => {
		let modalDiv = document.getElementById('disco82');
		if (!modalDiv) {
			modalDiv = document.createElement('div');
			modalDiv.id = 'disco82';
			modalDiv.classList.add('js-modal');
            modalDiv.classList.add('steering-committee-disclosures');
		}
        const modalHeader =`
        <header class="modal-header">
            <h4>Disclosures</h4>
            <button class="close-modal js-close-modal">
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L8 7.05719L14.8619 0.195262C15.1223 -0.0650874 15.5444 -0.0650874 15.8047 0.195262C16.0651 0.455612 16.0651 0.877722 15.8047 1.13807L8.94281 8L15.8047 14.8619C16.0651 15.1223 16.0651 15.5444 15.8047 15.8047C15.5444 16.0651 15.1223 16.0651 14.8619 15.8047L8 8.94281L1.13807 15.8047C0.877722 16.0651 0.455612 16.0651 0.195262 15.8047C-0.0650874 15.5444 -0.0650874 15.1223 0.195262 14.8619L7.05719 8L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z"
                fill="#020202"
                />
            </svg>
            </button>
        </header>`;
        const modalBody = facultySection.querySelector('.modal-content').innerHTML;
		modalDiv.innerHTML = `<div class="modal-inside">${modalHeader}<div class="modal-content">${modalBody}</div></div>`;
		resolve(modalDiv);
	});
}

export default _.catch(facultyBioVideo);